/**
 * ProposalsPage — Past proposals list (Phase 5 placeholder)
 */

import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { vortxColors, vortxTypography } from '@vortx/shared-ui';

function ProposalsPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', py: 4, px: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Typography
          variant="h4"
          sx={{ fontFamily: vortxTypography.heading, fontWeight: 700, color: vortxColors.charcoal }}
        >
          Proposals
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => navigate('/partner')}
          sx={{
            bgcolor: vortxColors.gold,
            fontWeight: 600,
            '&:hover': { bgcolor: vortxColors.darkGold || '#9a7a40' },
          }}
        >
          New Proposal
        </Button>
      </Box>

      <Alert severity="info">
        Proposal history coming in Phase 5. For now, proposals are saved as projects
        with type "partner_auto" — view them in Site DNA under All Projects.
      </Alert>
    </Box>
  );
}

export default ProposalsPage;
